import { DxReactAdapter } from '@labb/react-adapter';
import React from 'react';

export function registerMapping() {
  DxReactAdapter.registerMapping(
    'default',
    React.lazy(() => import('../../components/Default.tsx'))
  );

  DxReactAdapter.registerMapping(
    'TextInput',
    React.lazy(() => import('../../components/TextDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Email',
    React.lazy(() => import('../../components/TextDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Pega_Extensions_PasswordInput',
    React.lazy(() => import('../../components/PasswordDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Cmc_Extensions_SegmentedRadio',
    React.lazy(() => import('../../components/RadioGroupDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Cmc_Extensions_ActionLink',
    React.lazy(() => import('../../components/ActionLinkDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Date',
    React.lazy(() => import('../../components/TextDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Dropdown',
    React.lazy(() => import('../../components/SelectDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'FlowContainer',
    React.lazy(() => import('../../components/FlowContainer.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Phone',
    React.lazy(() => import('../../components/PhoneDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Checkbox',
    React.lazy(() => import('../../components/CheckboxDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'RadioButtons',
    React.lazy(() => import('../../components/SegmentedRadioDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Pega_Extensions_BannerInput',
    React.lazy(() => import('../../components/BannerInputDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'LabbLtd_Extensions_AddressLookup',
    React.lazy(() => import('../../components/AddressFinderDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Cmc_Extensions_AddressLookup',
    React.lazy(() => import('../../components/AddressFinderDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'View',
    React.lazy(() => import('../../components/View.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Cmc_Extensions_GuidedTextInput',
    React.lazy(() => import('../../components/OTPDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Group',
    React.lazy(() => import('../../components/Group.tsx'))
  );

  DxReactAdapter.registerMapping(
    'SimpleTable',
    React.lazy(() => import('../../components/SimpleTableDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'FieldGroupListItem',
    React.lazy(() => import('../../components/FieldGroupListItemDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Cmc_Extensions_DisplayParagraph',
    React.lazy(() => import('../../components/DisplayParagraphDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Cmc_Extensions_ProductSelection',
    React.lazy(() => import('../../components/ProductSelectionDX.tsx'))
  );

  DxReactAdapter.registerMapping(
    'Cmc_Extensions_SingpassLogin',
    React.lazy(() => import('../../singpass/SingpassLogin.tsx'))
  );
}
